import { render } from "./YearResults.vue?vue&type=template&id=52f211dc"
import script from "./YearResults.vue?vue&type=script&lang=ts"
export * from "./YearResults.vue?vue&type=script&lang=ts"
script.render = render

export default script